/**
 * Поля розділу «Навчання» → поняття довідника: `kb.<сутність>.<поле>` → термін словника.
 * Лише ті поля, для яких поняття справді пояснює правило фірми.
 */
export const LEARNING_FIELD_TERMS: Readonly<Record<string, string>> = {
  // Призначення курсу посадам: хто обіймає посаду, визначає посадова папка.
  'kb.assignment.position': 'Посадова папка',
  // Маршрут «введення на посаду» прив’язаний до посади та її папки.
  'kb.route.position': 'Посадова папка',
  // Прохідний бал тесту — поріг атестації знань.
  'kb.quiz.passThreshold': 'Атестація',
  // Підстава рішення про допуск: результати навчання й атестації.
  'kb.admission.basis': 'Атестація',
};
